import * as React from "react";

function SvgGoogleAds(props, ref) {
  return (
    <svg
      viewBox="0 0 486.667 444.667"
      height="1em"
      width="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M165.612 55.99c4.704-12.346 11.17-23.714 20.776-32.926 38.415-37.435 101.917-28.027 127.984 19.012 19.6 35.67 40.376 70.557 60.563 105.837 33.71 58.603 67.814 117.206 101.133 176.004 28.027 49.193-2.352 111.326-58.015 119.752-34.102 5.096-66.05-10.583-83.69-41.159-29.595-51.546-59.387-103.093-88.982-154.443-.588-1.176-1.372-2.156-2.156-3.135-3.136-2.55-4.508-6.273-6.468-9.605-13.13-23.127-26.654-46.059-39.786-68.99-8.428-14.896-17.248-29.596-25.675-44.492-7.644-13.326-11.172-27.83-10.78-43.118.588-7.84 1.568-15.679 5.096-22.736"
        fill="#5186ce"
      />
      <path
        d="M165.612 55.99c-1.764 7.058-3.333 14.113-3.724 21.56-.588 16.465 3.528 31.751 11.759 46.06 21.56 37.043 43.12 74.282 64.482 111.52 1.96 3.333 3.528 6.665 5.488 9.802a9759.336 9759.336 0 01-35.474 60.953c-16.464 28.42-32.927 57.035-49.587 85.454-.784 0-.98-.392-1.176-.98-.196-1.568.392-2.94.784-4.507 8.036-29.4 1.372-55.468-18.816-77.81-12.347-13.525-28.027-21.167-46.059-23.717-23.519-3.332-44.295 2.744-62.914 17.444-3.332 2.548-5.488 6.272-9.407 8.232-.785 0-1.177-.392-1.373-.98 9.408-16.268 18.62-32.534 28.027-48.804C86.43 192.796 125.236 125.373 164.24 58.148c.392-.785.98-1.372 1.372-2.157"
        fill="#f6b60b"
      />
      <path
        d="M20.38 309.61c3.723-3.333 7.25-6.86 11.171-9.997 47.627-37.63 119.165-10.388 129.553 49.195 2.548 14.308 1.175 28.027-3.136 41.747-.196 1.176-.392 2.155-.784 3.331-1.764 3.136-3.332 6.469-5.292 9.605-17.444 28.812-43.12 43.118-76.83 40.962-38.611-2.744-68.99-31.75-74.283-70.165-2.547-18.62 1.177-36.064 10.78-52.135 1.96-3.528 4.312-6.665 6.468-10.192.98-.784.588-2.352 2.352-2.352"
        fill="#3bad48"
      />
      <path
        d="M20.38 309.61c-.785.783-.785 2.155-2.157 2.351-.196-1.372.588-2.156 1.372-3.137l.784.785"
        fill="#f6b60b"
      />
      <path
        d="M157.184 393.886c-.784-1.371 0-2.35.784-3.331l.784.784-1.568 2.547"
        fill="#dabe12"
      />
    </svg>
  );
}

export default React.forwardRef(SvgGoogleAds);
